import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { CustomCell } from '../../components/custom-cell';

export const TABLE_COLUMNS = [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'name',
		flex: 2,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
